import {Controller} from "@hotwired/stimulus"
import {AllCommunityModule, ModuleRegistry, createGrid, themeQuartz} from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

export default class extends Controller {

  static targets = ['element', 'hitems', 'newRow']

  static values = {
    headers: {type: Array, default: []},
    url: {type: String, default: undefined},
    skey: {type: String, default: ''},
    rowModel: {type: String, default: 'infinite'},
    totalCount: Number,
    originalTotalCount: Number,
    rows: {type: Array, default: []},
    total: {type: Array, default: []}
  }

  connect() {
    this.originalTotalCountValue = this.totalCountValue
    let gridOptions = this.gridDataOptions()
    this.elementTarget.innerHTML = ''
    this.api = createGrid(this.elementTarget, gridOptions);
    let dataSource = {
      rowCount: this.totalCountValue, // behave as infinite scroll
      getRows: (params) => {
        console.log('asking for ' + params.startRow + ' to ' + params.endRow);
        if (params.startRow === 0 && params.endRow === 100 && params.sortModel.length === 0 && Object.keys(params.filterModel).length === 0) {
          let rowsThisPage = this.rowsValue;
          let lastRow = -1;
          if (this.totalCountValue <= params.endRow) {
            lastRow = this.totalCountValue;
          }
          params.successCallback(rowsThisPage, lastRow);
        } else {
          this.fetchData(params)
        }
      }
    }
    if (this.rowModelValue === 'infinite') {
      this.api.setGridOption('datasource', dataSource)
    }
  }

  gridDataOptions() {
    let obj = {}
    if (this.rowModelValue === 'infinite') {
      obj = {
        rowModelType: 'infinite',
      }
    } else {
      obj = {
        rowData: this.rowsValue
      }
    }
    obj['autoSizeStrategy'] = {
      type: 'fitCellContents'
    }
    obj['columnDefs'] = this.columnHeaders()
    obj['enableCellTextSelection'] = true
    if (this.hasTotalValue) {
      obj['pinnedBottomRowData'] = this.totalValue
    }
    obj.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        return {fontWeight: 'bold'};
      }
    }
    obj['theme'] = themeQuartz;
    return obj
  }

  download() {
    this.api.exportDataAsCsv()
  }

  fetchData(params) {
    let url = this.urlValue || window.location.href
    if (Object.keys(params.filterModel).length > 0) {
      var agFilter = btoa(JSON.stringify(params.filterModel))
      url = url + '&ag_filter=' + agFilter
      let filterElement = this.element.parentElement.querySelector('form > #ag_filter')
      if (filterElement) {
        filterElement.value = agFilter
      }
    }
    if (params.sortModel.length > 0) {
      var agSort = btoa(JSON.stringify(params.sortModel))
      url = url + '&ag_sort=' + agSort
      let sortElement = this.element.parentElement.querySelector('form > #ag_sort')
      if (sortElement) {
        sortElement.value = agSort
      }
    }
    fetch(url + '&offset=' + params.startRow + '&skey=' + this.skeyValue, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
      }
    }).then((response) => response.json()).then(result => {
      if (Object.keys(params.filterModel).length > 0 && params.startRow === 0) {
        this.totalCountValue = result.total_count
      } else if (Object.keys(params.filterModel).length === 0) {
        this.totalCountValue = this.originalTotalCountValue
      }
      if (this.hasTotalValue) {
        if (result.totals && result.totals.length > 0 && result.totals[0]) {
          this.totalValue = result.totals;
        }
        setTimeout(() => {
          this.api.setGridOption('pinnedBottomRowData', this.totalValue);
        }, 0);
      }
      let data = result.rows
      let lastRow = -1;
      if (this.totalCountValue <= params.endRow) {
        lastRow = this.totalCountValue;
      }
      params.successCallback(data, lastRow);
    })
  }

  columnHeaders() {
    let headers = this.headersValue;
    headers.forEach((item, index) => {
      this.parseObject(item)
    });
    return headers;
  }

  parseObject(item) {
    Object.keys(item).forEach((key) => {
      if (typeof (item[key]) === 'string' && item[key].includes('RAILS_JS')) {
        let matches = item[key].match(/RAILS_JS:((?!RAILS_JS:).*?):RAILS_JS_END/);
        if (matches && matches[1]) {
          let decodedFn = eval('(' + atob(matches[1]) + ')');
          if (typeof decodedFn === 'function') {
            item[key] = function (...args) {
              const params = args[0];
              if (params && params.node && !params.node.rowPinned && params.data === undefined) {
                return '';
              }
              try {
                return decodedFn.apply(this, args);
              } catch (e) {
                return '';
              }
            }
          } else {
            item[key] = decodedFn;
          }
        }
      }
    })
    if (item['children'] !== undefined) {
      item['children'].forEach((child, index) => {
        this.parseObject(child)
      });
    }
  }

  toggleColumn() {
    let hitems = this.hitemsTargets.map((x, index) => {
      if (x.checked) {
        return x.dataset['itemId'];
      }
    }).filter(n => n)
    let columns = this.columnHeaders().filter((col) => hitems.includes(col['colId'])).map((x, index) => {
      x['hide'] = false
      return x;
    })
    if (columns.length > 0) {
      this.api.setGridOption('columnDefs', columns)
    } else {
      this.api.setGridOption('columnDefs', this.columnHeaders())
    }
  }

  elementTargetDisconnected(ele) {
    this.api.destroy()
  }

  newRowTargetConnected(element) {
    let newItem = JSON.parse(element.dataset.value);
    this.api.applyTransaction({add: [newItem], addIndex: 0})
  }

  insertRowsToGrid(rows, headers) {
    this.api.setGridOption("columnDefs", headers);
    this.api.applyTransaction({add: rows, addIndex: 0})
  }

}
